let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("loQLa")).then(() => parcelRequire('bi7vZ'));